import news, { NewsState } from './news';
import sidebar, { SidebarState } from './sidebar';
import systemNotifications, {
  SystemNotificationsState,
} from './systemNotifications';
import ui, { UIState } from './ui';

export type CommonUnionState = {
  ui: UIState;
  news: NewsState;
  sidebar: SidebarState;
  systemNotifications: SystemNotificationsState;
};

export default { news, sidebar, systemNotifications, ui };
